export class CnstPMConfirmSaveParam
{
    confirmationValues: any;
    dispatchId: any;
    insertUserId: any;
    pMPersonId: any;
}
